import { EntityBase } from '@provision/entity-types';
import { ReactNode } from 'react';
import { CustomViewEntity } from 'src/graphql/entities/custom-view';
import { ConversationAttribute } from 'src/graphql/entities/custom-view/custom-view-config/conversation';
import { ProjectAttribute } from 'src/graphql/entities/custom-view/custom-view-config/project';
import { SiteAttribute } from 'src/graphql/entities/custom-view/custom-view-config/site';
import { conversationCustomComponents } from './conversation-map';
import { ServiceLevelField } from './service-level-field';

type CustomComponentRow = EntityBase & {
  snoozeUntil?: string | null;
  cppExpDate?: string | null;
  address?: { cppExpDate?: string | null } | null;
};

type CustomCellComponent = (value: string, row: CustomComponentRow) => ReactNode;

const renderServiceLevel: CustomCellComponent = (value, row) => (
  <ServiceLevelField
    displayName={value}
    cppExpDate={row.cppExpDate ?? row.address?.cppExpDate}
  />
);

export const customComponentsMap: Record<
  CustomViewEntity,
  Partial<Record<string, CustomCellComponent>>
> = {
  conversation: {
    ...conversationCustomComponents,
    [ConversationAttribute.serviceLevel]: renderServiceLevel,
  },
  site: {
    [SiteAttribute.clientActivatedMembership]: renderServiceLevel,
  },
  project: {
    [ProjectAttribute.clientActivatedMembership]: renderServiceLevel,
  },
  client: {},
};
